var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLightOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;}.cls-2{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Light_off_46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 46,
    height: 46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.7,37.45V29.87A1.65,1.65,0,0,0,16,28.48a13.06,13.06,0,1,1,14.1,0,1.65,1.65,0,0,0-.75,1.4v7.58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.74,39.9H29.3a0,0,0,0,1,0,0v1.18a3.77,3.77,0,0,1-3.77,3.77h-5a3.77,3.77,0,0,1-3.77-3.77V39.9a0,0,0,0,1,0,0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightOff);
export default __webpack_public_path__ + "static/media/icon_light_off.81e537816f155c76da3ce1b7946a51a2.svg";
export { ForwardRef as ReactComponent };